
import { useState, useEffect } from 'react';
import { SubscriptionPlan } from '@/types/subscriptionPlans';
import { getBusinessSignupPlans, subscribeToBusinessPlanChanges, getBusinessPlanById } from '@/utils/businessPlanUtils';

export const useBusinessPlans = () => {
  const [businessPlans, setBusinessPlans] = useState<SubscriptionPlan[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [selectedPlan, setSelectedPlan] = useState<SubscriptionPlan | null>(null);

  useEffect(() => {
    // Initial fetch of business plans
    const fetchPlans = () => {
      const plans = getBusinessSignupPlans();
      setBusinessPlans(plans);
      setIsLoading(false);
    };

    fetchPlans();

    // Subscribe to plan changes
    const unsubscribe = subscribeToBusinessPlanChanges((updatedPlans) => {
      console.log('Business plans updated:', updatedPlans);
      setBusinessPlans(updatedPlans);
      
      // If there was a selected plan, update it with the new data
      if (selectedPlan) {
        const updatedSelectedPlan = updatedPlans.find(plan => plan.id === selectedPlan.id);
        if (updatedSelectedPlan) {
          setSelectedPlan(updatedSelectedPlan);
        }
      }
    });

    return () => {
      unsubscribe();
    };
  }, [selectedPlan]);
  
  // Function to select a plan by ID
  const selectPlan = (planId: string) => {
    const plan = getBusinessPlanById(planId);
    setSelectedPlan(plan);
    return plan;
  };

  return {
    businessPlans,
    isLoading,
    selectedPlan,
    selectPlan
  };
};
